var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"access-denied-container"},[_c('h2',[_c('em',{staticClass:"mr-3 fas fa-lock"}),_vm._v("Zugriff auf Seite verweigert")])])}]

export { render, staticRenderFns }